import $ from "jquery/dist/jquery";

$(() => {
  $(document).on("change", ".facetfilter select, .facetfilter input", function (e) {
    const f = $(e.target).closest("form.facetfilter");
    if (!f.hasClass("facet-auto-apply")) {
      return;
    }
    if ($(e.target).hasClass("facet-auto-apply-disable")) {
      return;
    }
    f.submit();
  });

  $(document).on("slide-change", ".facetfilter .facet-slider", function (e) {
    const f = $(e.target).closest("form.facetfilter");
    if (!f.hasClass("facet-auto-apply")) {
      return;
    }
    if ($(e.target).hasClass("facet-auto-apply-disable")) {
      return;
    }
    f.submit();
  });

  $(document).on("submit", ".facetfilter", function (e) {
    const f = $(e.target);
    const url = f.attr("action");
    const result_target = $(f.attr("data-facet-result-target"));
    const result_target_menu_addon = $(f.attr("data-facet-result-menu-addon-target"));

    if (!f.hasClass("facet-auto-apply")) {
      return;
    }

    if (!result_target.length && !result_target_menu_addon.length) {
      return;
    }

    e.preventDefault();

    let data = f.serializeArray();
    data.push({ name: "contentOnly", value: "1" });

    $.ajax({
      method: "get",
      url: url,
      data: $.param(data),
    })
      .done((d) => {
        result_target.html(d.item_content);
        result_target_menu_addon.html(d.menu_addon);
        result_target.find(".facetfilter .facet-slider").facetSlider();
        result_target_menu_addon.find(".facetfilter .facet-slider").facetSlider();
      })
      .fail(() => {
        window.location = url;
      });
  });
});
